module.exports = __webpack_public_path__ + "static/img/front_goal.17cde9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/front_goal.png
// module id = 9uGq
// module chunks = 79